import dayjs from 'dayjs';

const INVALID_DATE_VALUES = new Set(['invalid date', 'undefined', 'null', 'nan']);

export const getResConfirmationDatePrefix = (confoCreate?: string | null): string => {
  const normalizedConfoCreate = typeof confoCreate === 'string' ? confoCreate.trim() : '';

  if (normalizedConfoCreate && !INVALID_DATE_VALUES.has(normalizedConfoCreate.toLowerCase())) {
    const parsedDate = dayjs(normalizedConfoCreate);
    if (parsedDate.isValid()) {
      return parsedDate.format('MMDDYYYY');
    }
  }

  return dayjs().format('MMDDYYYY');
};

export const getResConfirmationNumberValue = (
  confoCreate?: string | null,
  reservationNumber?: string | null
): string => {
  return `${getResConfirmationDatePrefix(confoCreate)}${reservationNumber ?? ''}`;
};

export const normalizeResConfirmationNumberValue = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  const trimmedValue = value.trim();
  return trimmedValue.replace(/^(invalid date|undefined|null|nan)/i, getResConfirmationDatePrefix());
};
